import { Layout, Menu } from 'antd'
import Sider from 'antd/lib/layout/Sider'
import React, { memo } from 'react'
import styles from './index.module.less'
import logo from '@/assets/logo-with-text-deep.png'
import { Outlet, Link, useMatch } from 'react-router-dom'

const { Header, Content } = Layout

const menuItems = [
  {
    key: 'dimension',
    label: (
      <span>
        <Link to='dimension'>Dimensions</Link>
      </span>
    )
  },
  {
    key: 'components',
    label: (
      <span>
        <Link to='components'>Components</Link>
      </span>
    )
  },
  {
    key: 'property-sets',
    label: (
      <span>
        <Link to='property-sets'>Physical Property Set</Link>
      </span>
    )
  },
  {
    key: 'equipment',
    label: (
      <span>
        <Link to='equipment'>Equipment</Link>
      </span>
    )
  },
  {
    key: 'nozzle-shapes',
    label: (
      <span>
        <Link to='nozzle-shapes'>Nozzle Shapes</Link>
      </span>
    )
  },
  {
    key: 'palette-containers',
    label: (
      <span>
        <Link to='palette-containers'>Palette Containers</Link>
      </span>
    )
  },
  {
    key: 'contact-info',
    label: (
      <span>
        <Link to='contact-info'>Contact Infomations</Link>
      </span>
    )
  },
  {
    key: 'subscription',
    label: (
      <span>
        <Link to='subscription'>Subscription</Link>
      </span>
    )
  },
  {
    key: 'plan-permissions',
    label: (
      <span>
        <Link to='plan-permissions'>Plan Permissions</Link>
      </span>
    )
  },
  {
    key: 'plan-setting',
    label: (
      <span>
        <Link to='plan-setting'>Plan Setting</Link>
      </span>
    )
  }
]

export default memo(function AdminLayout() {
  const matches = useMatch('/admin/:feature/*')

  return (
    <Layout hasSider className={styles.container}>
      <Sider width={240} className={styles.sider}>
        <div className={styles.logo}>
          <img height={24} src={logo} alt='logo' />
        </div>
        <Menu mode='inline' items={menuItems} defaultSelectedKeys={[matches?.params.feature || 'dimension']} />
      </Sider>

      <Layout>
        <Header className={styles.header} />
        <Content className={styles.content}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
})
